import { render } from "./ManagePermissions.vue?vue&type=template&id=4e29e012"
import script from "./ManagePermissions.vue?vue&type=script&lang=js"
export * from "./ManagePermissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__